import { workspaceContractUrl } from '../urls';
import refresh from '../refresh';

export default async function getWorkspaceContract(workspaceId, version) {
  return refresh(async () => {
    const response = await fetch(`${workspaceContractUrl}?${new URLSearchParams({
      workspace: workspaceId,
      version,
    })}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
    return response;
  });
}
